import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-8f14029e")
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "area" }
const _hoisted_3 = { class: "msg" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "¡Listo!", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = { class: "step-button" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Image, {
            src: require('@/assets/images/check.svg'),
            alt: "Image Text",
            class: "picture",
            width: "35",
            height: "25"
          }, null, 8, ["src"]),
          _hoisted_4,
          (_ctx.currentRoute === 'ProfileCreated')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_5, "Se creó el perfil de la empresa"))
            : _createCommentVNode("", true),
          (_ctx.currentRoute === 'ProfileEdited')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_6, "Se actualizó el perfil de la empresa"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.redirectHome())),
              label: "Finalizar",
              class: "next",
              type: "submit"
            })
          ])
        ])
      ])
    ])
  ]))
}